import { FilledStarIcon } from '@/components/icons';
import PlaceHolder from '@/components/icons/shop/PlaceHolder';
import { useOrientation } from '@/hooks';

const ReviewSkeleton = () => {
    const { isHorizontal } = useOrientation();

    return (
        <div className="widescreen:flex-col widescreen:py-[calc(50*var(--vh-unit))] flex justify-center gap-[calc(16*var(--vw-unit))]">
            <div className="bg-bg-gray-f9 h-[calc(404*var(--vh-unit))] w-[calc(410*var(--vw-unit))] rounded-lg border px-[calc(36*var(--vw-unit))] py-[calc(50*var(--vh-unit))] shadow-sm">
                <div className="flex flex-col space-y-[calc(26*var(--vh-unit))]">
                    {/* Loading bars with 20px spacing */}
                    <div className="flex justify-start">
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(87*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                    </div>
                    <div className="flex justify-between">
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(170*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(45*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                    </div>
                    <div className="flex justify-between">
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(110*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(65*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                    </div>
                    <div className="flex justify-between">
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(170*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                        <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(45*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                    </div>
                </div>
            </div>

            {isHorizontal ? (
                <div className="bg-bg-gray-f9 h-[calc(208*var(--vh-unit))] w-[calc(410*var(--vw-unit))] rounded-lg border px-[calc(20*var(--vw-unit))] py-[calc(24*var(--vh-unit))] shadow-sm">
                    <div className="flex gap-[calc(16*var(--vw-unit))]">
                        {/* Left Block: 5 stars + rounded div */}
                        <div className="flex justify-center">
                            <div className="bg-ebe8e5 h-[calc(160*var(--vh-unit))] w-[calc(160*var(--vw-unit))] animate-pulse rounded">
                                <PlaceHolder />
                            </div>
                        </div>

                        {/* Right Block: 5 stars + description */}
                        <div className="flex flex-col justify-start gap-[calc(16*var(--vh-unit))]">
                            <div className="flex justify-between">
                                <div className="flex space-x-[calc(4*var(--vw-unit))]">
                                    {[...Array(5)].map((_, index) => (
                                        <div key={index} className="h-[calc(16*var(--vh-unit))] w-[calc(16*var(--vw-unit))] animate-pulse">
                                            <FilledStarIcon width={20} height={20} fill="var(--color-ebe8e5)" />
                                        </div>
                                    ))}
                                </div>
                                <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(63*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                            </div>
                            <div className="space-y-[calc(6*var(--vh-unit))]">
                                <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(200*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                                <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(200*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                                <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(110*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="bg-bg-gray-f9 h-[calc(404*var(--vh-unit))] w-[calc(240*var(--vw-unit))] rounded-lg border px-[calc(20*var(--vw-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(28*var(--vh-unit))] shadow-sm">
                    <div className="flex flex-col space-y-[calc(20*var(--vh-unit))]">
                        {/* Top Block: 5 stars + rounded div */}
                        <div className="flex justify-between">
                            <div className="flex space-x-[calc(4*var(--vw-unit))]">
                                {[...Array(5)].map((_, index) => (
                                    <div key={index} className="h-[calc(16*var(--vh-unit))] w-[calc(16*var(--vw-unit))] animate-pulse">
                                        <FilledStarIcon width={20} height={20} fill="var(--color-ebe8e5)" />
                                    </div>
                                ))}
                            </div>
                            <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(63*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                        </div>

                        {/* Middle Block: Square placeholder image */}
                        <div className="flex justify-center">
                            <div className="bg-ebe8e5 h-[calc(200*var(--vh-unit))] w-[calc(200*var(--vw-unit))] animate-pulse rounded">
                                <PlaceHolder />
                            </div>
                        </div>

                        {/* Bottom Block: 3 rounded divs */}
                        <div className="space-y-[calc(6*var(--vh-unit))]">
                            <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(200*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                            <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(200*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                            <div className="bg-ebe8e5 h-[calc(18*var(--vh-unit))] w-[calc(110*var(--vw-unit))] animate-pulse rounded-[calc(9*var(--vw-unit))]"></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReviewSkeleton;
